/**
 * Escapes text for the HTML-rendering spots that take raw strings: toast text (rendered with the
 * `safe: 'html'` pipe, i.e. not sanitized) and table TextColumn cells (innerHTML).
 */
export function escapeHtml(text: string): string {
  return text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}
